module.exports = __webpack_public_path__ + "img/widgets.b5f12b0b.svg";